"use client";
import React from 'react';
import Button from '@/components/primitives/button';
import { scrollToSection } from '@/utils';


export default function ViewPicks() {
  return (
    <Button size="xs" onClick={() => scrollToSection("game-detail-pick-activity", 132)}>View Picks</Button>
  )
}
